export default __webpack_public_path__ + "static/media/low sodium.82466fd3.jpg";